import { FilterKey } from '@/models/FilterKey';
import { IFilterProvider } from '@/interfaces/filter-providers/IFilterProvider';
import Filter from '@/Filter.class';
import { EventAggregationService } from '@/platform/EventAggregationService';

export default class FormatFilter extends Filter {
	public constructor(filterProvider: IFilterProvider, eventAggregationService?: EventAggregationService) {
		super(FilterKey.ATTENDANCE, filterProvider, eventAggregationService);
	}
}
